namespace TabAurous.Finance {
    export interface ReceiptDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        LedgerId?: number;
        PartyType?: string;
        LedgerName?: string;
        Amount?: number;
        ExchangeRateId?: number;
        RefNo?: string;
        ChequeNo?: string;
        ChequeDate?: string;
        Mode?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ReceiptDetailsRow {
        export const idProperty = 'TransDetailId';
        export const localTextPrefix = 'Finance.ReceiptDetails';
        export const deletePermission = 'Finance:Receipt:Delete';
        export const insertPermission = 'Finance:Receipt:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Receipt:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ExchangeRateId = "ExchangeRateId",
            RefNo = "RefNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Mode = "Mode",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
